
import React from 'react'
import { Link } from 'react-router-dom'

function ComingSoon() {
  return (
    <div>
      <div className="coming-soon parallax">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-lg-4">
              <div className="full-height coming-soon-img"> <img src="/tm/react/bycycle/assets/images/soon.jpg" className="image-fit" alt="img"/> </div>
            </div>
            <div className="col-lg-8">
              <div className="full-height coming-soon-text">
                <h1 className="text-custom-black">Coming Soon</h1>
                <div className="counter">
                  <div className="counter-box">
                    <div className="inner-box"><span className="text-custom-white" id="cvdays"></span> </div>
                    <p className="text-custom-white">Days</p>
                  </div>
                  <div className="counter-box">
                    <div className="inner-box"><span className="text-custom-white" id="cvhours"></span> </div>
                    <p className="text-custom-white">Hours</p>
                  </div>
                  <div className="counter-box">
                    <div className="inner-box"> <span className="text-custom-white" id="cvminutes"></span> </div>
                    <p className="text-custom-white">Minutes</p>
                  </div>
                  <div className="counter-box">
                    <div className="inner-box"> <span className="text-custom-white" id="cvseconds"></span> </div>
                    <p className="text-custom-white">Seconds</p>
                  </div>
                </div>
                <div className="coming-soon-contact">
                  <ul className="custom-flex">
                    <li>
                      <label className="text-light-dark fw-600 d-block">Phone:</label>
                      <Link to="tel:" className="text-custom-black fw-600">(+123) 123 4567 890</Link> </li>
                    <li>
                      <label className="text-light-dark fw-600 d-block">Address:</label>
                      <Link to="#" className="text-custom-black fw-600">AENEAN VULPUTATE PORTTITOR</Link> </li>
                    <li>
                      <label className="text-light-dark fw-600 d-block">Email Us:</label>
                      <Link to="mailto:" className="text-custom-black fw-600">info@domain.com</Link> </li>
                  </ul>
                </div>
                <div className="newsletter-form">
                  <div className="form-group">
                    <div className="input-group group-form">
                      <input type="text" name="#" className="form-control form-control-custom" placeholder="Email Id"/>
                      <button className="input-group-append"> Send </button>
                    </div>
                  </div>
                </div>
                <div className="social-media">
                  <ul className="custom-flex">
                    <li> <Link to="#" className="text-light-dark"> <i className="fab fa-facebook-f"></i> </Link> </li>
                    <li> <Link to="#" className="text-light-dark"> <i className="fa-brands fa-x-twitter"></i> </Link> </li>
                    <li> <Link to="#" className="text-light-dark"> <i className="fab fa-instagram"></i> </Link> </li>
                    <li> <Link to="#" className="text-light-dark"> <i className="fab fa-youtube"></i> </Link> </li>
                    <li> <Link to="#" className="text-light-dark"> <i className="fab fa-google-plus"></i> </Link> </li>
                    <li> <Link to="#" className="text-light-dark"> <i className="fab fa-vimeo"></i> </Link> </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ComingSoon